import { BsFacebook, BsInstagram, BsTiktok, BsLinkedin } from "react-icons/bs";
import { AiFillYoutube } from "react-icons/ai";
import "./Footer.css";

const Footer = ({ storeData }) => {
  const footerTextColor = storeData?.color?.FooterTextColor || "#000000";

  const socialLinks = [
    { icon: <BsFacebook />, name: "FaceBook", url: storeData?.FacebookUrl },
    { icon: <AiFillYoutube />, name: "YouTube", url: storeData?.YouTubeUrl },
    { icon: <BsInstagram />, name: "Instagram", url: storeData?.InstagramUrl },
    { icon: <BsTiktok />, name: "TikTok", url: storeData?.TikTokUrl },
    { icon: <BsLinkedin />, name: "LinkedIn", url: storeData?.LinkedInUrl },
  ];

  return (
    <div className="footer-Top-box">
      <h3 style={{ color: footerTextColor }}>Follow Us</h3>
      <ul>
        {socialLinks.map(
          (social, index) =>
            social.url && (
              <li key={index} style={{ color: footerTextColor }}>
                {social.icon}{" "}
                <a
                  target="blank"
                  href={social.url}
                  style={{ color: footerTextColor }}
                >
                  {social.name}
                </a>
              </li>
            )
        )}
      </ul>
    </div>
  );
};

export default Footer;
